import {html} from 'lit';
import {customElement} from 'lit/decorators.js';
import {map} from 'rxjs';

import * as D from './decimal_utils';
import {Panel} from './panel';
import {ri} from './runner-idle';

@customElement('ri-batches')
export class Batches extends Panel {
  // #region Properties (2)

  public override id = 'batches';
  public override name = 'Batches';

  // #endregion Properties (2)

  // #region Constructors (1)

  constructor() {
    super();
    this.unlock$ = ri.stats.intelligence.value$.pipe(map(D.gte(10)));
  }

  // #endregion Constructors (1)

  // #region Public Methods (1)

  public override render() {
    return super.render(html` <input
        ?hidden=${ri.editingBatch !== null}
        id="batch-name-input"
        type="text"
        placeholder="Batch Name"
      />
      <button
        ?hidden=${ri.editingBatch !== null}
        @click=${() => {
          const batchNameEl = ri.shadowRoot?.getElementById(
            'batch-name-input'
          ) as HTMLInputElement;
          if (
            batchNameEl?.value &&
            !ri.activityQueue.some(
              (q) => q.activity.displayName == batchNameEl.value
            )
          ) {
            ri.createBatchFromQueue(batchNameEl.value);
            batchNameEl.value = '';
          }
        }}
      >
        Create Batch
      </button>

      <button
        ?hidden=${!ri.editingBatch}
        @click=${() => {
          const batchNameEl = ri.shadowRoot?.getElementById(
            'batch-name-input'
          ) as HTMLInputElement;
          if (batchNameEl) {
            batchNameEl.value = '';
          }
          ri.togglePause(ri.lastGameSpeed == 0);
          ri.lastLoadoutIndex = ri.beforeBatchLoadoutIndex;
          ri.beforeBatchLoadoutIndex = -1;
          ri.editingBatch = null;
          ri.activityQueue = ri.loadouts[ri.lastLoadoutIndex];
          ri.activityQueueIndex = 0;
          ri.requestUpdate();
        }}
      >
        Stop Editing ${ri.editingBatch?.displayName}
      </button>`);
  }

  // #endregion Public Methods (1)
}
